import React, { useState } from 'react';
import WordTranslationExercise from './WordTranslationExercise';
import './WordTranslationExerciseBoard.css';

const WORD_TRANSLATION_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)', marginRight: 20
  }}>
    <svg width="28" height="28" viewBox="0 0 512 512" fill="white">
      <g>
        <g>
          <path d="m385.421 379.639-20.889-41.778-20.889 41.778z"/>
        </g>
        <g>
          <path d="m467.019 217.065h-21.252v-44.963c0-4.242-1.796-8.285-4.943-11.129s-7.354-4.221-11.571-3.794c-2.388.242-55.886 6.292-82.521 59.886h-21.796v32.889c0 41.345-33.637 74.981-74.981 74.981h-32.889v142.083c0 24.803 20.179 44.981 44.981 44.981h204.972c24.802.001 44.981-20.178 44.981-44.98v-204.972c0-24.803-20.179-44.982-44.981-44.982zm-176.116 200.972 60.212-120.425c2.541-5.082 7.735-8.292 13.417-8.292s10.875 3.21 13.417 8.292l60.213 120.425c3.705 7.41.701 16.419-6.708 20.125s-16.42.702-20.125-6.708l-10.907-21.814h-71.778l-10.907 21.814c-2.628 5.256-7.926 8.295-13.428 8.295-2.254 0-4.543-.51-6.696-1.587-7.411-3.705-10.414-12.715-6.71-20.125z"/>
        </g>
        <g>
          <path d="m161.681 126.34h-28.427c1.856 14.861 6.613 27.356 14.214 37.424 7.6-10.068 12.357-22.563 14.213-37.424z"/>
        </g>
        <g>
          <path d="m249.954 294.935c24.803 0 44.981-20.179 44.981-44.981v-204.972c0-24.803-20.179-44.982-44.981-44.982h-204.972c-24.803 0-44.982 20.179-44.982 44.982v204.972c0 24.803 20.179 44.981 44.981 44.981h21.252v44.963c0 4.242 1.796 8.285 4.943 11.129 2.77 2.503 6.358 3.871 10.056 3.871.503 0 1.01-.025 1.515-.077 2.388-.242 55.886-6.292 82.521-59.886zm-94.492-86.062c-2.624-1.4-5.304-2.981-7.994-4.74-2.691 1.759-5.37 3.341-7.994 4.74-25.594 13.65-51.143 13.807-52.218 13.807-8.284 0-15-6.716-15-15s6.716-15 15-15c.132-.001 18.639-.27 37.054-9.732-10.536-13.492-18.84-31.799-21.239-56.608h-15.816c-8.284 0-15-6.716-15-15s6.716-15 15-15h45.213v-9.085c0-8.284 6.716-15 15-15s15 6.716 15 15v9.085h45.212c8.284 0 15 6.716 15 15s-6.716 15-15 15h-15.814c-2.4 24.809-10.703 43.116-21.239 56.608 18.414 9.462 36.924 9.73 37.115 9.732 8.284 0 14.969 6.716 14.969 15s-6.747 15-15.031 15c-1.075 0-26.624-.156-52.218-13.807z"/>
        </g>
        <g>
          <path d="m365.669 85.819c2.929 2.929 6.768 4.394 10.606 4.394s7.678-1.464 10.606-4.394c5.858-5.858 5.858-15.355 0-21.213l-4.306-4.306c55.209 3.271 99.125 49.215 99.125 105.231 0 8.284 6.716 15 15 15s15-6.716 15-15c0-72.673-57.543-132.151-129.458-135.286l4.639-4.639c5.858-5.858 5.858-15.355 0-21.213-5.857-5.857-15.355-5.858-21.213 0l-30.105 30.107c-5.858 5.858-5.858 15.355 0 21.213z"/>
        </g>
        <g>
          <path d="m146.032 425.881c-5.857-5.858-15.355-5.858-21.213 0s-5.858 15.355 0 21.213l4.306 4.306c-55.209-3.27-99.125-49.215-99.125-105.231 0-8.284-6.716-15-15-15s-15 6.716-15 15c0 72.673 57.543 132.151 129.458 135.286l-4.639 4.639c-5.858 5.858-5.858 15.355 0 21.213 2.929 2.929 6.768 4.393 10.606 4.393s7.678-1.464 10.606-4.394l30.106-30.106c5.858-5.858 5.858-15.355 0-21.213z"/>
        </g>
      </g>
    </svg>
  </span>
);

const WordTranslationExerciseBoard = ({
  exerciseData, exerciseType: _exerciseType, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false, myState = {}, otherState = {}, updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;
  const { pairs, title, targetLanguage } = exerciseData;

  if (!pairs || !Array.isArray(pairs)) {
    return (
      <div className="word-translation-board-error">
        <p>Error: Invalid Word Translation exercise data</p>
      </div>
    );
  }

  return (
    <div className="word-translation-exercise-board">
      {!isExpanded ? (
        <div
          className={`word-translation-preview unified-exercise-preview wt-board-card${isSelected ? ' is-selected' : ''}`}
          onClick={() => {
            if (isExpandedProp === undefined) setIsExpandedLocal(true);
            if (onSelect) onSelect();
            if (onExpand) onExpand();
          }}
        >
          {WORD_TRANSLATION_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{title || 'Word Translation Exercise'}</div>
            <div className="unified-preview-meta">
              {pairs.length} word pairs · Target: {targetLanguage || 'English'}
            </div>
          </div>
          <button className="unified-preview-btn">
            Start Exercise
          </button>
        </div>
      ) : (
        <div className="wte-expanded">
          <WordTranslationExercise
            pairs={pairs}
            title={title}
            targetLanguage={targetLanguage}
            onClose={() => { if (isExpandedProp === undefined) setIsExpandedLocal(false); if (onClose) onClose(); }}
            onUpdate={onUpdate}
            isBoard={true}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default WordTranslationExerciseBoard; 